import React, { Component } from "react";
import { isEqual } from "lodash";
import { SearchBar } from "component/menu";
import { ReactComponent as TypesIcon } from "assets/icons/Types.svg";
import { ReactComponent as ScratchCardsIcon } from "assets/icons/scratch cards.svg";
import { ReactComponent as SlotIconActive } from "assets/icons/Slots-active.svg";
import { ReactComponent as SlotIconInactive } from "assets/icons/Slots-inactive.svg";
import { ReactComponent as TableGamesIconActive } from "assets/icons/TableGames-active.svg";
import { ReactComponent as TableGamesIconInactive } from "assets/icons/TableGames-inactive.svg";
import { ReactComponent as VirtualSportsIconActive } from "assets/icons/VirtualSports-active.svg";
import { ReactComponent as VirtualSportsIconInactive } from "assets/icons/VirtualSports-inactive.svg";
import { ReactComponent as CrashGamesIconActive } from "assets/icons/CrashGames-active.svg";
import { ReactComponent as CrashGamesIconInactive } from "assets/icons/CrashGames-inactive.svg";
import { ReactComponent as LiveCasinoIconActive } from "assets/icons/LiveCasino-active.svg";
import { ReactComponent as LiveCasinoIconInactive } from "assets/icons/LiveCasino-inactive.svg";
import { ReactComponent as InstantWinIconActive } from "assets/icons/InstantWin-active.svg";
import { ReactComponent as InstantWinIconInactive } from "assets/icons/InstantWin-inactive.svg";
import { ReactComponent as LotteryIconActive } from "assets/icons/Lottery-active.svg";
import { ReactComponent as LotteryIconInactive } from "assets/icons/Lottery-inactive.svg";
import { ReactComponent as ShootingIconActive } from "assets/icons/Shooting-active.svg";
import { ReactComponent as ShootingIconInactive } from "assets/icons/Shooting-inactive.svg";
import { ReactComponent as GameShowsIconActive } from "assets/icons/GameShows-active.svg";
import { ReactComponent as GameShowsIconInactive } from "assets/icons/GameShows-inactive.svg";
import { ReactComponent as EsportsIconActive } from "assets/icons/ESports-active.svg";
import { ReactComponent as EsportsIconInactive } from "assets/icons/Esports-inactive.svg";
import { ReactComponent as SportsIconActive } from "assets/icons/Sports-active.svg";
import { ReactComponent as SportsIconInactive } from "assets/icons/Sports-inactive.svg";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { withNamespaces } from "react-i18next";

class CombinedCategoryGameTypeFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expand: true,
      showMoreGameType: false,
      search: "",
      filteredCategoryValues: props.categoryFilter
        ? this.filterValues(props.categoryFilter.get("values"), "")
        : null,
      filteredGameTypeValues: props.gameTypeFilter
        ? this.filterValues(props.gameTypeFilter.get("values"), "")
        : null,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.categoryFilter, this.props.categoryFilter) ||
      !isEqual(prevProps.gameTypeFilter, this.props.gameTypeFilter)
    ) {
      this.setState({
        filteredCategoryValues: this.props.categoryFilter
          ? this.filterValues(
              this.props.categoryFilter.get("values"),
              this.state.search
            )
          : null,
        filteredGameTypeValues: this.props.gameTypeFilter
          ? this.filterValues(
              this.props.gameTypeFilter.get("values"),
              this.state.search
            )
          : null,
      });
    }
  }

  filterValues = (values, search) => {
    return values.filter((value) => {
      if (!value.get("enabled")) return false;
      if (!search) return true;
      return value.get("name").toLowerCase().includes(search.toLowerCase());
    });
  };

  handleSearchInput = (value) => {
    this.setState({
      search: value,
      filteredCategoryValues: this.props.categoryFilter
        ? this.filterValues(this.props.categoryFilter.get("values"), value)
        : null,
      filteredGameTypeValues: this.props.gameTypeFilter
        ? this.filterValues(this.props.gameTypeFilter.get("values"), value)
        : null,
    });
  };

  toggleExpand = () => {
    this.setState({ expand: !this.state.expand });
  };

  toggleShowMoreGameType = () => {
    this.setState({ showMoreGameType: !this.state.showMoreGameType });
  };

  highlightText = (text, search) => {
    if (!search || !text) return text;
    const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="search-highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  renderCategoryItem = (value) => {
    const isActive = value.get("toggled");
    let Icon;

    switch (value.get("id")) {
      case "INSTANTWIN":
        Icon = isActive ? InstantWinIconActive : InstantWinIconInactive;
        break;
      case "SLOT":
        Icon = isActive ? SlotIconActive : SlotIconInactive;
        break;
      case "VIRTUAL_SPORTS":
        Icon = isActive ? VirtualSportsIconActive : VirtualSportsIconInactive;
        break;
      case "TABLEGAME":
        Icon = isActive ? TableGamesIconActive : TableGamesIconInactive;
        break;
      case "SCRATCHCARD":
        Icon = ScratchCardsIcon;
        break;
      case "ESPORTS":
        Icon = isActive ? EsportsIconActive : EsportsIconInactive;
        break;
      case "LIVECASINO":
        Icon = isActive ? LiveCasinoIconActive : LiveCasinoIconInactive;
        break;
      case "LOTTERY":
        Icon = isActive ? LotteryIconActive : LotteryIconInactive;
        break;
      case "SHOOTING":
        Icon = isActive ? ShootingIconActive : ShootingIconInactive;
        break;
      case "CRASH":
        Icon = isActive ? CrashGamesIconActive : CrashGamesIconInactive;
        break;
      case "GAME_SHOW":
        Icon = isActive ? GameShowsIconActive : GameShowsIconInactive;
        break;
      case "SPORTS":
        Icon = isActive ? SportsIconActive : SportsIconInactive;
        break;
      default:
        Icon = isActive ? SlotIconActive : SlotIconInactive;
        break;
    }

    return (
      <div
        className={`col-4 category-icon text-center ${isActive ? "toggled" : ""}`}
        key={value.get("id")}
        onClick={(e) => {
          e.stopPropagation();
          this.props.onFilterClickHandler(this.props.categoryFilter.get("id"), value);
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div className="icon">
            <Icon />
            <div className="w-100 category-name">
              {this.highlightText(value.get("name"), this.state.search)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderGameTypeItem = (value) => {
    const imageUrl = value.getIn(["leadingIcon", "imgUrl"]);
    const finalImageUrl = imageUrl ? `${imageUrl}&theme=dark` : null;

    return (
      <div
        className={`row align-items-center ${value.get("toggled") ? "selected" : ""}`}
        key={value.get("id")}
        onClick={(e) => {
          e.stopPropagation();
          this.props.onFilterClickHandler(this.props.gameTypeFilter.get("id"), value);
        }}
      >
        <div className="col d-flex align-items-center">
          {finalImageUrl && (
            <img className="item-icon" src={finalImageUrl} alt={value.get("name")} />
          )}
          <span>{this.highlightText(value.get("name"), this.state.search)}</span>
        </div>
        <div className="col-auto form-check-label">
          <span>{value.get("count")}</span>
        </div>
        { this.props.gameTypeFilter && <div className="col-auto">
          <input
            className="form-check-input"
            type={this.props.gameTypeFilter.get("isMultiSelectable") ? "checkbox" : "radio"}
            checked={value.get("toggled") || false}
            readOnly
          />
          </div>
        }
      </div>
    );
  };

  render() {
    const { t } = this.props;
    const { expand, showMoreGameType, filteredCategoryValues, filteredGameTypeValues, search } = this.state;

    const originalCategoryValues = this.props.categoryFilter
      ? this.props.categoryFilter.get("values").filter(v => v.get("enabled")).toArray()
      : [];
    const originalGameTypeValues = this.props.gameTypeFilter
      ? this.props.gameTypeFilter.get("values").filter(v => v.get("enabled")).toArray()
      : [];
    const originalCategoryEnabledCount = originalCategoryValues.length;
    const originalGameTypeEnabledCount = originalGameTypeValues.length;

    const hasAnyVisibleContent = (originalCategoryEnabledCount > 1) || (originalGameTypeEnabledCount > 1);
    if (!hasAnyVisibleContent) {
      return null;
    }

    const categorySize = filteredCategoryValues ? filteredCategoryValues.size : 0;
    const gameTypeSize = filteredGameTypeValues ? filteredGameTypeValues.size : 0;

    const showCategorySection = (originalCategoryEnabledCount > 1) && categorySize > 0;
    const showGameTypeSection = (originalGameTypeEnabledCount > 0) && gameTypeSize > 0;

    const totalEnabled = categorySize + gameTypeSize;
    const hideSearch = totalEnabled <= 10 && !search;

    const categoryToggled = this.props.categoryFilter ? this.props.categoryFilter.get("toggledCount") : 0;
    const gameTypeToggled = this.props.gameTypeFilter ? this.props.gameTypeFilter.get("toggledCount") : 0;
    const totalToggled = categoryToggled + gameTypeToggled;

    const selectedNames = [];
    if (this.props.categoryFilter) {
      this.props.categoryFilter.get("values").forEach(v => {
        if (v.get("toggled")) selectedNames.push(v.get("name"));
      });
    }
    if (this.props.gameTypeFilter) {
      this.props.gameTypeFilter.get("values").forEach(v => {
        if (v.get("toggled")) selectedNames.push(v.get("name"));
      });
    }

    const gameTypeList = filteredGameTypeValues ? filteredGameTypeValues.toArray() : [];
    const initialGameTypeCount = 10;
    const displayedGameTypeValues = showMoreGameType
      ? gameTypeList
      : gameTypeList.slice(0, initialGameTypeCount);

    return (
      <div className="accordion-item">
        <div className="accordion-header" onClick={this.toggleExpand}>
          <div className="accordion-button w-100">
            <div className="row">
              <div className="col">
                <div>
                  <span className="filter-icon">
                    <TypesIcon />
                  </span>
                  {t("types")}
                  {totalToggled > 0 && ` (${totalToggled})`}
                </div>
                <div className="sub">
                  {selectedNames.join(", ")}
                </div>
              </div>
              <div className="col-auto">
                {expand ? <ArrowUp /> : <ArrowDown />}
              </div>
            </div>
          </div>
        </div>

        <div className={`accordion-collapse collapse ${expand ? "show" : ""}`}>
          <SearchBar
            placeholder={t("findType")}
            search={search}
            hide={hideSearch}
            onInput={this.handleSearchInput}
          />

          {showCategorySection && (
            <div className="combined-section">
              <div className="row nopadding">
                {filteredCategoryValues.map(this.renderCategoryItem)}
              </div>
            </div>
          )}

          {showGameTypeSection && (
            <div className="combined-section">
              <div className={`accordion-body ${showMoreGameType ? "expand" : ""}`}>
                {displayedGameTypeValues.map(this.renderGameTypeItem)}
              </div>
              {gameTypeSize > initialGameTypeCount && (
                <div className="expand-link" onClick={this.toggleShowMoreGameType}>
                  <span className="btn btn-link">
                    {!showMoreGameType
                      ? `+${gameTypeSize - initialGameTypeCount} ${t("more")}`
                      : t("less")}
                  </span>
                </div>
              )}
            </div>
          )}

          {totalEnabled === 0 && (
            <div className="row-no-result disabled">
              <div className="col text-center">{t("noResultFound")}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(CombinedCategoryGameTypeFilter);
